
export const toTitleCase = (value: string): string => {
  return value.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
};

export const isRouteParam = (segment: string): boolean => {
  if (segment.startsWith(':')) {
    return true;
  }

  const specificParamsToHide = [
    'investigationticketid',
    'oldmotornumber',
    'childticket',
    'investigationflowid',
    'null',
    'undefined',
  ];

  const lowerSegment = segment.toLowerCase();

  if (specificParamsToHide.includes(lowerSegment)) {
    return true;
  }

  return (
    /^\d+$/.test(segment) || 
    /^[a-f0-9-]{36}$/i.test(segment) ||
    /^[A-Z]{2,4}-\d+$/i.test(segment) || 
    /^[A-Z]+\d+$/i.test(segment) || 
    (/^\w{8,}$/.test(segment) && 
      (/^\w+\d+\w*$/.test(segment) || 
        /^[A-F0-9]+$/i.test(segment))) || 
    (/^\w{15,}$/.test(segment) && !/[a-z-]/.test(segment.slice(1))) 
  );
};

export const extractRouteParameters = (
  pathname: string,
  routePattern: string,
  paramNames: string[]
): Record<string, string> => {
  
  const pathParts = pathname.split('/').filter(Boolean);
  const patternParts = routePattern.split('/').filter(Boolean);
  const parameters: Record<string, string> = {};

  let matchIndex = -1;
  for (let i = 0; i <= pathParts.length - patternParts.length; i++) {
    let matches = true;
    for (let j = 0; j < patternParts.length; j++) {
      const pathPart = pathParts[i + j];
      const patternPart = patternParts[j];

      if (!patternPart.startsWith(':') && pathPart !== patternPart) {
        matches = false;
        break;
      }
    }
    if (matches) {
      matchIndex = i;
      break;
    }
  }

  if (matchIndex !== -1) {
    patternParts.forEach((patternPart, index) => {
      if (patternPart.startsWith(':')) {
        const paramName = patternPart.substring(1);
        const pathIndex = matchIndex + index;
        if (pathIndex < pathParts.length && paramNames.includes(paramName)) {
          parameters[paramName] = pathParts[pathIndex];
        }
      }
    });
  }

  return parameters;
};

export const buildRouteUrl = (routePattern: string, parameters: Record<string, string>): string => {
  let url = routePattern;

  Object.entries(parameters).forEach(([paramName, paramValue]) => {
    url = url.replace(`:${paramName}`, paramValue);
  });

  return url;
};
